import { Navigate, Route, Routes } from "react-router";
import Login from "./pages/login/Login";
import Main from "./pages/main/Main";
import Layout from "./components/layout/Layout";
import Categories from "./pages/categories/Categories";
import Items from "./pages/items/Items";

const Router = () => {
  return (
    <Routes>
      <Route path='/' element={<Navigate to='/login' replace />} />
      <Route path='/login' element={<Login />} />

      <Route path='/panel' element={<Layout />}>
        <Route index element={<Main />} />
        <Route path='/panel/categories' element={<Categories />} />
        <Route path='/panel/category/:categoryId' element={<Items />} />
      </Route>
    </Routes>
  );
};

export default Router;
